var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReorderIcon = function SvgReorderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#reorder-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.25 5.002V2.625c0-.623-.502-1.125-1.125-1.125S0 2.002 0 2.625v5.25C0 8.498.502 9 1.125 9h5.25C6.998 9 7.5 8.498 7.5 7.875S6.998 6.75 6.375 6.75H3.783A9.74 9.74 0 0 1 12 2.25 9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75a9.68 9.68 0 0 1-5.377-1.617 1.126 1.126 0 0 0-1.247 1.875A11.97 11.97 0 0 0 12 24c6.628 0 12-5.372 12-12S18.628 0 12 0a11.98 11.98 0 0 0-9.75 5.002M12 6c-.623 0-1.125.502-1.125 1.125V12c0 .3.117.586.328.797l3.375 3.375a1.125 1.125 0 0 0 1.59-1.59l-3.048-3.046V7.125C13.12 6.502 12.62 6 11.995 6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reorder-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgReorderIcon;